import React,{ forwardRef, ReactNode } from 'react';
import { Box, SxProps, Theme } from '@mui/material';

interface ChartContainerProps {
    children: ReactNode;
    height?: string | number;
    minHeight?: string | number;
    width?: string | number;
    sx?: SxProps<Theme>;
}

export const ChartContainer = forwardRef<HTMLDivElement, ChartContainerProps>(
    ({ children, height = '100%', minHeight = '300px', width = '100%', sx }, ref) => {
        return (
            <Box
                ref={ref}
                sx={{
                    height,
                    minHeight,
                    width,
                    marginTop: '10px',
                    ...sx,
                }}
            >
                {children}
            </Box>
        );
    }
);

ChartContainer.displayName = 'ChartContainer';
